import ErrorModal from './ErrorModal.js';

export default ErrorModal;
